import * as React from 'react';
import { OrganizationContact, OrganizationContactFlag, OrganizationContactFlags } from '../../../../amorg-common';
import { Button } from '../../../../designSystem/button/Button';
import { Flex } from '../../../../designSystem/compositeComponents/FlexHelpers';
import { FormField } from '../../../../designSystem/formField/FormField';
import { MessageCard } from '../../../../designSystem/Message';
import { Modal } from '../../../../designSystem/Modal';
import { TextArea } from '../../../../designSystem/inputs/TextArea';
import { TextInput } from '../../../../designSystem/inputs/TextInput';
import { SafeFlagSelector } from '../../../../designSystem/compositeComponents/SafeFlagSelector';

type OrganizationContactModalProps = {
    contact: OrganizationContact | null,
    showModal: boolean,
    error: string,
    onCancel: () => void,
    onSave: (contact: Omit<OrganizationContact, 'id'>) => Promise<boolean>
}

export function OrganizationContactModal (props: OrganizationContactModalProps): JSX.Element
{
    const [name, setName] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [note, setNote] = React.useState('');
    const [flags, setFlags] = React.useState<OrganizationContactFlag[]>([]);

    React.useEffect(() =>
    {
        setName(props.contact?.name ?? '');
        setEmail(props.contact?.email ?? '');
        setPhone(props.contact?.phone ?? '');
        setNote(props.contact?.note ?? '');
        setFlags(props.contact?.flags ?? []);
    }, [props.contact, props.showModal]);

    async function handleSave ()
    {
        const saved = await props.onSave({ name, email, phone, note, flags });
        if (saved)
            props.onCancel();
    }

    return (
        <Modal
            title={props.contact ? 'Rediger kontakt' : 'Opret kontakt'}
            showModal={props.showModal}
            onCancel={props.onCancel}
            content={
                <Flex flexDirection="column" gap={16}>
                    <MessageCard variant="error" hide={props.error === ''}>{props.error}</MessageCard>

                    <FormField
                        label="Navn"
                        inputComponent={<TextInput value={name} onChange={setName} placeholder="Navn" />}
                    />
                    <FormField
                        label="Email"
                        inputComponent={<TextInput value={email} onChange={setEmail} placeholder="Email" />}
                    />
                    <FormField
                        label="Telefon"
                        inputComponent={<TextInput value={phone} onChange={setPhone} placeholder="Telefon" />}
                    />
                    <FormField
                        label="Note"
                        inputComponent={<TextArea minRows={3} value={note} onChange={setNote} placeholder="Note" />}
                    />

                    <SafeFlagSelector
                        allowedFlags={OrganizationContactFlags.map(flag => flag)}
                        selectedFlags={flags}
                        onChange={(newFlags) => setFlags(newFlags as OrganizationContactFlag[])}
                    />

                    <Flex justifyContent="space-between">
                        <Button variant="text" text="Annuller" onClick={props.onCancel} />
                        <Button
                            variant="filled"
                            text={props.contact ? 'Gem ændringer' : 'Opret kontakt'}
                            onClick={handleSave}
                        />
                    </Flex>
                </Flex>
            }
        />
    );
}
